<!--
 * @Author: your name
 * @Date: 2020-11-13 16:01:51
 * @LastEditTime: 2021-03-16 14:22:34
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \xy_project\src\views\Home\common\Contact.vue
-->
<template>
  <div id="contact">
    <!-- 协会管理员 -->
    <el-row class="goBackHome" v-if="roleType==2&&$parent.tabIndex==5">
      <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">
        <span class="clickBack" @click="$parent.tabIndex=0"><img src="@/assets/img/back.png" alt="">返回</span>
      </el-col>
      <el-col :xs="22" :sm="22" :md="22" :lg="22" :xl="22">
        <span style="color: #333333;">我的工作台 > </span>{{quesNaireData.applyName}}
      </el-col>
    </el-row>
    <!-- 协会会员 -->
    <el-row class="goBackHome" v-if="roleType==3&&$parent.tabIndex==5">
      <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">
        <span class="clickBack" @click="$parent.tabIndex=0"><img src="@/assets/img/back.png" alt="">返回</span>
      </el-col>
      <el-col :xs="22" :sm="22" :md="22" :lg="22" :xl="22">
        <span style="color: #333333;">我的申请 > </span>{{quesNaireData.applyName}}
      </el-col>
    </el-row>
    <template v-if="quesNaireData">
      <el-row class="quesStartInfo" v-if="(quesNaireData.recipientPerson==null||quesNaireData.recipientPerson==''||quesNaireData.recipientPerson==userId)&&roleType==2&&quesNaireData.applyStatus!=5&&quesNaireData.applyStatus!=4">
        <el-col :xs="14" :sm="14" :md="14" :lg="14" :xl="14" class="applyColor">
          <el-row style="margin-bottom:10px;">
            <el-col :xs="16" :sm="16" :md="16" :lg="16" :xl="16">
              公司名 :
              <span class="leftMargin">{{quesNaireData.companyName}}</span>
            </el-col>
            <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
              发起时间 :
              <span class="leftPadding"> {{quesNaireData.createTime.substr(0,10)}}</span>
            </el-col>
          </el-row>
          <el-row>
            申请内容 : <span class="leftPadding">{{quesNaireData.applyName}}</span>
          </el-row>
        </el-col>
        <template v-if="quesNaireData.taskStatus==2">
          <el-col class=" taskBack" :xs="5" :sm="5" :md="5" :lg="5" :xl="5">
            <div @click="taskBack">
              任务退回
              <img src="@/assets/img/任务退回.png" alt="">
            </div>
          </el-col>
          <el-col style="text-align:right;margin-right:20px;" :xs="5" :sm="5" :md="5" :lg="5" :xl="5">
            <el-button class="button add esc" @click="$refs.ExamineDialog.isSuccess(5)">同意</el-button>
            <el-button class="button esc" @click="$refs.ExamineDialog.applyVisible = true">拒绝</el-button>
          </el-col>
        </template>
        <template v-if="quesNaireData.taskStatus==1">
          <el-col class="receiveTask" :xs="10" :sm="10" :md="10" :lg="10" :xl="10">
            <el-button class="button receive" @click="acceptTask">接受任务</el-button>
          </el-col>
        </template>
      </el-row>
      <el-row class="applyReason" v-if="roleType == 2 && $route.name == 'AdminApplication'&&remarkReason.length>0">
        <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">原因说明：</el-col>
        <el-col :xs="22" :sm="22" :md="22" :lg="22" :xl="22">{{remarkReason}}</el-col>
      </el-row>
    </template>
    <el-row class="addContact" v-if="roleType==3&&$parent.tabIndex!=5" @click.native="addTel">
      <i class="el-icon-plus"> 添加联系人</i>
    </el-row>
    <el-table :data="telTableData" stripe style="width: 100%">
      <el-table-column type="index" label="#">
      </el-table-column>
      <el-table-column prop="contactName" label="联系人姓名">
        <template slot-scope="scope">
          {{scope.row.contactName}}
          <div class="mainPerson" v-if="scope.row.contactStatus==2">负责人</div>
        </template>
      </el-table-column>
      <el-table-column prop="position" label="职位">
      </el-table-column>
      <el-table-column prop="fixedTelephone" label="固定电话">
      </el-table-column>
      <el-table-column prop="mobilePhone" label="移动电话">
      </el-table-column>
      <el-table-column prop="email" label="邮箱">
      </el-table-column>
      <el-table-column prop="comment" label="备注">
        <template slot-scope="scope">
          <el-popover placement="top-start" title="详情" width="200" trigger="hover" :content="scope.row.comment==null||scope.row.comment==''?'无':scope.row.comment" v-if="scope.row.comment!=null||scope.row.comment!=''">
            <span class="downLoad" slot="reference">查 看</span>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column label="操作" v-if="roleType==3&&$parent.tabIndex!=5">
        <template slot-scope="scope">
          <span v-if="scope.row.approveStatus==1" class="applyAdd">申请添加中</span>
          <span v-else-if="scope.row.approveStatus==2" class="applyAdd">申请修改中</span>
          <span v-else-if="scope.row.approveStatus==3" class="applyAdd">申请删除中</span>
          <template v-else-if="scope.row.approveStatus==5">
            <span class="downLoad" @click="editContent(scope.row)">修 改</span>
            <span class="downLoad delete" @click="deleteContent(scope.row)">删 除</span>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination v-if="roleType == 3||(roleType == 2&&$route.name=='Management')" @current-change="handleTelChange" :current-page.sync="telParams.pageNumber" :page-size="telParams.pageSize" layout="total, prev, pager, next" :total="telTotal">
    </el-pagination>
    <!-- 添加联系人对话框 -->
    <el-dialog :title="telTitleName" :visible.sync="addContectVisible" width="30%" custom-class="addInfoVisible" @close="closeContDialog">
      <template v-if="addSuccess==0">
        <el-alert v-if="telFlag==2"
          title="若修改审核未通过，则原来的联系人信息也会被删除"
          type="warning" :closable="false" show-icon
        >
        </el-alert>
        <el-form :model="addTelForm" :rules="addTelFormRules" ref="addTelForm" label-width="130px" class="demo-ruleForm">
          <el-form-item label="是否设为负责人" prop="switchValue">
            <el-switch v-model="addTelForm.switchValue" active-text="是" inactive-text="否" @change="handleStatus">
            </el-switch>
          </el-form-item>
          <el-form-item label="联系人" prop="contactName">
            <el-input v-model="addTelForm.contactName"></el-input>
          </el-form-item>
          <el-form-item label="职位" prop="position">
            <el-input v-model="addTelForm.position"></el-input>
          </el-form-item>
          <el-form-item label="固定电话" prop="fixedTelephone">
            <el-input v-model="addTelForm.fixedTelephone"></el-input>
          </el-form-item>
          <el-form-item label="移动电话" prop="mobilePhone">
            <el-input v-model="addTelForm.mobilePhone"></el-input>
          </el-form-item>
          <el-form-item label="邮箱" prop="email">
            <el-input v-model="addTelForm.email"></el-input>
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="addTelForm.comment"></el-input>
          </el-form-item>
          <el-form-item label="修改原因" prop="remark" v-if="telFlag==2">
            <el-input type="textarea" v-model="addTelForm.remark"></el-input>
          </el-form-item>
        </el-form>
      </template>
      <div v-if="addSuccess==1" style="text-align:center;">
        <img src="@/assets/img/修改成功.png" alt="">
        <p style="font-size:16px;font-weight:700;margin:15px 0;">提交成功</p>
        <span v-if="telFlag==1">添加联系人已提交,正等待管理员审核!</span>
        <span v-if="telFlag==2">修改联系人已提交,正等待管理员审核!</span>
        <span v-if="telFlag==3">删除联系人已提交,正等待管理员审核!</span>
      </div>
      <el-row v-if="addSuccess==2">
        <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5" style="padding-left:20px;font-size:15px;">删除原因</el-col>
        <el-col :xs="19" :sm="19" :md="19" :lg="19" :xl="19">
          <el-input type="textarea" class="deleteReason" placeholder="请填写删除原因" v-model="addTelForm.remark"></el-input>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <span v-if="addSuccess==0" class="button add" type="primary" @click="addTelInfo">确 定</span>
        <span v-if="addSuccess==2" class="button add" type="primary" @click="deleteInfo">确定</span>
        <span v-if="addSuccess==1" class="button add" type="primary" @click="addSuccessfull">确定</span>
        <span class="button" v-if="addSuccess==0||addSuccess==2" @click="addContectVisible = false">取 消</span>
      </span>
    </el-dialog>
    <!-- 审批同意拒绝对话框 -->
    <ExamineDialog ref="ExamineDialog" />
    <!-- 任务退回对话框 -->
    <BackDialog ref="BackDialog" />
  </div>
</template>
<script>
import ExamineDialog from '@/views/Home/common/ExamineDialog'
import BackDialog from '@/views/Home/common/BackDialog.vue'
import { findContactInfo, addContactInfo, delContactInfo, taskManagement } from '@/api/index'
export default {
  props: ['quesNaireData'],
  data() {
    return {
      userId: sessionStorage.getItem('userId'),
      roleType: window.sessionStorage.getItem('roleType'),
      addContectVisible: false,
      telTableData: [],
      addSuccess: 0,
      telFlag: 1,
      addTelForm: {
        id: '',
        remark: "",
        contactStatus: 1,
        contactName: '',
        position: '',
        fixedTelephone: '',
        mobilePhone: '',
        email: '',
        comment: '',
        switchValue: true,
      },
      addTelFormRules: {
        // switchValue: [
        //   { required: true, message: '请输入职称', trigger: 'blur' },
        // ],
        contactName: [
          { required: true, message: '请输入名称', trigger: 'blur' },
        ],
        position: [
          { required: true, message: '请输入职位', trigger: 'blur' },
        ],
        fixedTelephone: [
          { required: true, message: '请输入固定电话', trigger: 'blur' },
        ],
        mobilePhone: [
          { required: true, message: '请输入移动电话', trigger: 'blur' },
        ],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
        ],
        remark: [
          { required: true, message: '请输入修改原因', trigger: 'blur' },
        ],
      },
      telTitleName: "",
      telParams: {
        userId: '',
        pageNumber: 1,
        pageSize: 5,
      },
      telTotal: 0,
      remarkReason: ""
    }
  },
  created() {
    this.getTelInfo()
  },
  methods: {
    // refuse() {
    //   this.$children[4].applyVisible = true
    // },
    // 任务退回
    taskBack() {
      this.$refs.BackDialog.titleName = '任务退回'
      this.$refs.BackDialog.refuseVisible = true
      this.$refs.BackDialog.step = 1
      this.$refs.BackDialog.receiveParams.id = this.quesNaireData.id
    },
    // 接受任务
    async acceptTask() {
      this.$refs.BackDialog.receiveParams.id = this.quesNaireData.id
      this.$refs.BackDialog.receiveParams.taskStatus = 2
      const { data } = await taskManagement(this.$refs.BackDialog.receiveParams)
      if (data.code != 0) return
      this.quesNaireData.taskStatus = 2
      this.$parent.findAllTask()
    },
    async getTelInfo() {
      if ((this.roleType == 2 && this.$route.name == 'AdminApplication') || (this.roleType == 3 && this.$route.name == 'Application')) {
        this.telTableData = [JSON.parse(this.quesNaireData.param)]
        this.remarkReason = this.telTableData[0].remark
      } else {
        if (this.roleType == 3) {
          this.telParams.userId = this.userId
        } else if (this.roleType == 2) {
          this.telParams.userId = this.$route.query.id || this.quesNaireData.createUserId
        }
        const { data } = await findContactInfo(this.telParams)
        if (data.code != 0) return
        this.telTableData = data.contactInformationList
        this.telTotal = data.total
      }
    },
    addTel() {
      this.addContectVisible = true
      this.telFlag = 1
      this.addSuccess = 0
      this.telTitleName = '添加联系人'
    },
    addTelInfo() {
      this.$refs.addTelForm.validate(async valid => {
        if (valid) {
          try{
            const { data } = await addContactInfo(this.addTelForm)
            if (data.code == 0) {
              this.addSuccess = 1
              // this.addContectVisible = false
              // this.getTelInfo()
              // sessionStorage.setItem('addTelForm', this.addTelForm)

            } else {
              this.$message.error(data.msg)
            }
          }catch(err){
            console.log(err);
            if(err.data.code == 500 ){
              this.$message.error(err.data.msg)
            }
          }
          
        }
      })
    },
    addSuccessfull() {
      this.addContectVisible = false
      this.getTelInfo()
    },
    handleStatus(val) {
      if (val) {
        this.addTelForm.contactStatus = 2
      } else {
        this.addTelForm.contactStatus = 1
      }
    },
    closeContDialog() {
      if (this.addSuccess == 1 || this.addSuccess == 2) {
        this.addTelForm = {
          id: '',
          remark: "",
          contactStatus: 1,
          contactName: '',
          position: '',
          fixedTelephone: '',
          mobilePhone: '',
          email: '',
          comment: '',
          switchValue: false,
        }
      } else {
        this.$refs.addTelForm.resetFields()

      }
    },
    editContent(row) {
      this.telTitleName = '修改联系人'
      this.telFlag = 2
      this.addSuccess == 0
      this.addContectVisible = true
      this.addTelForm.id = row.id
      if (row.contactStatus == 2) {
        this.addTelForm.switchValue = true
      } else if (row.contactStatus == 1) {
        this.addTelForm.switchValue = false
      }
      this.addTelForm.contactName = row.contactName
      this.addTelForm.position = row.position
      this.addTelForm.fixedTelephone = row.fixedTelephone
      this.addTelForm.mobilePhone = row.mobilePhone
      this.addTelForm.email = row.email
      this.addTelForm.comment = row.comment
    },
    deleteContent(row) {
      this.telTitleName = '申请删除'
      this.telFlag = 3
      this.addSuccess = 2
      this.addContectVisible = true
      this.addTelForm.id = row.id
    },
    async deleteInfo() {
      if (this.addTelForm.remark == '') {
        this.$message.error('请填写删除信息!')
      } else {
        const { data } = await delContactInfo(this.addTelForm)
        if (data.code != 0) return
        this.addSuccess = 1
      }
    },
    handleTelChange(val) {
      this.telParams.pageNumber = val
      this.getTelInfo()
    },
  },
  components: {
    ExamineDialog,
    BackDialog
  }
}
</script>
<style lang='less' scoped>
#contact {
  .mainPerson {
    background-color: #ecf5ff;
    color: #409eff;
    border: 1px solid #d9ecff;
    display: inline-block;
    height: 24px;
    padding: 0 8px;
    line-height: 22px;
    font-size: 12px;
    margin-left: 10px;
  }
}
</style>